import { AxiosRequestConfig } from 'axios'
import { useApi } from '../hooks'
import { DeviceGroup, DeviceGroupInput } from '../types'

const api = useApi('v2')

async function getDeviceGroups(config?: AxiosRequestConfig): Promise<DeviceGroup[]> {
  const response = await api.get<DeviceGroup[]>('/device-groups', config)

  return response.data
}

export async function getDeviceGroup(
  id: number,
  config?: AxiosRequestConfig
): Promise<DeviceGroup> {
  const response = await api.get<DeviceGroup>(`/device-groups/${id}`, config)

  return response.data
}

async function createDeviceGroup(input: DeviceGroupInput): Promise<DeviceGroup> {
  const response = await api.post<DeviceGroup>('/device-groups', input)

  return response.data
}

export async function updateDeviceGroup(id: number, input: DeviceGroupInput): Promise<DeviceGroup> {
  const response = await api.put<DeviceGroup>(`/device-groups/${id}`, input)

  return response.data
}

async function deleteDeviceGroup(id: number): Promise<void> {
  await api.delete(`/device-groups/${id}`)
}

export default {
  getDeviceGroups,
  createDeviceGroup,
  getDeviceGroup,
  updateDeviceGroup,
  deleteDeviceGroup
}
